import { Component, OnInit, AfterViewChecked, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { PaymentstatusService } from './paymentstatus.service';
import { LoadingService } from '../loading-spinner/loading.service';
import { AnswerFromSimple } from '../answer-from-simple';

import { PaymentStatusResponse } from './paymentstatus-response';
import { CustomResponse } from '../../shared/custom-response';
import { SimplePaymentStatus as SimplePaymentStatusRequest } from './simple-payment-status';
import { ShoppingcartService } from '../shoppingcart.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiRequestService } from '../../shared/api-request-service';
import { PaymentStatus } from './paymentstatus';
import { AnswerToCreateOrderRequest } from '../answer-to-create-order-request';
import { retry, map } from 'rxjs/operators';
import { InitializePaymentResponse } from '../initialize-payment-response';
import { PaymentRequest } from '../payment-request';
import { Material } from '../material';

@Component({
    selector: 'lib-paymentstatus',
    templateUrl: './paymentstatus.component.html',
    styleUrls: ['./paymentstatus.component.scss']
})
export class PaymentstatusComponent implements OnInit {
    status: string = '';
    paymentStatusResponse?: PaymentStatusResponse;
    paymentStatus?: string;
    answerFromSimple?: AnswerFromSimple = {};
    customResponse?: CustomResponse = {};
    simplePaymentStatusRequest?: SimplePaymentStatusRequest = {};
    apiUrl = '/order/status';
    paymentApiUrl = '/order/pay';
    answerToCreateOrderRequest: AnswerToCreateOrderRequest = {};
    isPaymentStatusFailed = false;
    paymentRequest?: PaymentRequest = {};
    language: string = '';
    orderBackendUrl = '';

    constructor(
        private route: ActivatedRoute,
        private _shoppingcartService: ShoppingcartService,
        private _http: HttpClient,
        private _loadingService: LoadingService,
        private _paymentStatusService: PaymentstatusService,
        private _apiRequestService: ApiRequestService,
        private _shoppingCartService: ShoppingcartService,
        private _router: Router,
        @Inject('ORDER_BACKEND_URL') private _orderBackendUrl: string
    ) {
        this.orderBackendUrl = _orderBackendUrl;
    }

    ngOnInit(): void {
        this.paymentRequest = JSON.parse(sessionStorage.getItem('paymentRequest') as string) as PaymentRequest;
        this.language = JSON.parse(sessionStorage.getItem('language') as string) as string;
        this._loadingService.show();
        this.route.queryParams.subscribe((paymentStatus) => {
            if (!paymentStatus) {
                this._router.navigateByUrl('/');
            }

            this.answerFromSimple = {
                r: paymentStatus['r'],
                s: paymentStatus['s']
            };

            this.simplePaymentStatusRequest = {
                signature: this.answerFromSimple.s,
                paymentDetails: this.answerFromSimple.r,
                language: this.language
            };

            this.answerToCreateOrderRequest = this._shoppingcartService.answerToCreateOrderRequest as AnswerToCreateOrderRequest;
            this._apiRequestService
                .sendRequest<SimplePaymentStatusRequest, PaymentStatusResponse>(
                    this.orderBackendUrl,
                    true,
                    this.simplePaymentStatusRequest,
                    true,
                    this.apiUrl
                )
                .pipe(
                    map((respone: PaymentStatusResponse) => {
                        if (respone.paymentStatus.toString() === PaymentStatus[PaymentStatus.WAITING_FOR_CONFIRMATION].toString()) {
                            throw respone;
                        } else if (respone.paymentStatus.toString() === PaymentStatus[PaymentStatus.FAIL].toString()) {
                            this.isPaymentStatusFailed = true;
                        } else if (respone.paymentStatus.toString() === PaymentStatus[PaymentStatus.SUCCESS].toString()) {
                            sessionStorage.removeItem('paymentRequest');
                        }
                        this.paymentStatusResponse = respone;
                        return respone;
                    }),
                    retry({ count: 150, delay: 2000 })
                )
                .subscribe(() => this._loadingService.hide());
        });
    }
    public get paymentStatuss(): typeof PaymentStatus {
        return PaymentStatus;
    }

    goToPay() {
        this._loadingService.show();
        this._apiRequestService
            .sendRequest<PaymentRequest | undefined, InitializePaymentResponse>(
                this.orderBackendUrl,
                true,
                this.paymentRequest,
                true,
                this.paymentApiUrl
            )
            .subscribe((paymentResponse: InitializePaymentResponse) => {
                if (paymentResponse?.paymentUrl) {
                    window.location.href = paymentResponse.paymentUrl;
                    sessionStorage.removeItem('language');
                } else {
                    //TODO: handle missing url
                }
            });
    }
    //TODO status 'fail' nincs pénz a kártyáján, 'timeout' kifutott az időből, 'cancel' ha visszalép
    //TODO statusTömb kell h checkoljam h egyezik e backend a frontent statussal
    //TODO ha nem egyezik a válasz a tömb elemével akkor error
    //TODO ha failed akkor Sikertelen fizetés majd újra fizetés gomb
    //TODO ha email linkről fizet, akkor az orderId az urlbe fog jönni, megírni ilyenre h tudja fogadni
    //TODO simple visszaküldi az orderId-t
    //TODO status-t és orderReferencest visszaküldeni backendnek
    //TODO environment-be localhost, vagy ha dockerben fut akkor pw-order/ az url
}
